const items = [
  "Built on Integrity",
  "Driven by Excellence",
  "Lee's Summit, Missouri",
  "Quality Renovations",
  "Exceptional Results",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {items.map((t) => (
      <span key={t} className="flex items-center">
        <span className="font-display italic font-light text-2xl sm:text-4xl text-[#F5F5F5]/80 whitespace-nowrap px-10 sm:px-16">
          {t}
        </span>
        <span className="w-2 h-2 rotate-45 bg-[#D4AF37]/70 shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="relative py-14 sm:py-20 border-y border-[#D4AF37]/15 overflow-hidden"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="marquee-track">
        <Row />
        <Row />
      </div>
    </div>
  );
}
